import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { LoadingOverlay } from 'dashboard/components/common';
import { timeAgo } from './timeAgo';

const STATUS_COLOR = { new: 'primary', read: 'default', archived: 'secondary' };

/**
 * Left column of the inbox — clickable rows for each message.
 *
 * Active message gets a green left border. Messages with `status:
 * 'new'` get a subtle highlight bg so unread ones stand out before
 * the user opens them (and the parent marks them read).
 */
export default function InboxList({ items, loading, selectedId, onOpen }) {
  return (
    <Box
      sx={{
        width: { xs: '100%', md: '320px' },
        borderRight: { md: '1px solid' },
        borderColor: 'divider',
        maxHeight: 600,
        overflowY: 'auto',
      }}
    >
      <LoadingOverlay loading={loading && items.length === 0} minHeight={120}>
        {!loading && items.length === 0 && (
          <Box p='14px'>
            <Typography variant='body2' color='text.secondary'>No messages.</Typography>
          </Box>
        )}
        {items.map((m) => {
          const isActive = m._id === selectedId;
          return (
            <Box
              key={m._id}
              onClick={() => onOpen(m)}
              sx={{
                p: '12px 14px',
                borderBottom: '1px solid', borderColor: 'divider',
                borderLeft: '3px solid',
                borderLeftColor: isActive ? 'success.main' : 'transparent',
                bgcolor: m.status === 'new' ? 'action.hover' : 'transparent',
                cursor: 'pointer',
              }}
            >
              <Stack direction='row' alignItems='center' mb='4px' gap='6px'>
                <Typography variant='body2' fontWeight='700' noWrap sx={{ flex: 1, minWidth: 0 }}>
                  {m.name || m.email || 'No name'}
                </Typography>
                <Chip
                  size='small'
                  label={m.status}
                  color={STATUS_COLOR[m.status] || 'default'}
                  sx={{ height: 18, fontSize: '0.6em' }}
                />
              </Stack>
              <Typography variant='caption' color='text.secondary' noWrap display='block'>
                {m.subject || '(no subject)'}
              </Typography>
              <Typography variant='caption' color='text.secondary' mt='4px' display='block'>
                {timeAgo(m.createdAt)}
              </Typography>
            </Box>
          );
        })}
      </LoadingOverlay>
    </Box>
  );
}
